export default {
	REGULAR: '1',
	VIDEO: '2',
	QUICK_LAUNCH: '3',
	TIME_TO_CLIMB: '4',
	DRAW_IT: '5',
	OPEN_ENDED_QUESTION: '6',
	MATCHING_PAIRS: '7',
	STANDALONE_ACTIVITIES: '100',
}
